var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 7,
    viewBox: "0 0 11 7",
    width: 11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m206.176471 7.82352941v6.17647059h.823529v-7h-7v.82352941z",
    fill: "#2980b9",
    transform: "matrix(-.70710678 .70710678 -.70710678 -.70710678 156.820851 -134.971609)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownCaret);
export default __webpack_public_path__ + "static/media/icon-down-caret.2044906921644f825267b20d5c5dafca.svg";
export { ForwardRef as ReactComponent };